import script from "./course-layoutv2.vue?vue&type=script&setup=true&lang=js"
export * from "./course-layoutv2.vue?vue&type=script&setup=true&lang=js"

import "./course-layoutv2.vue?vue&type=style&index=0&id=244274dc&lang=css"

const __exports__ = script;

export default __exports__